export default "__VITE_ASSET__b568b452__"